export default {"src":"/_next/static/media/client-07.cfd0d412.svg","height":23,"width":83,"blurWidth":0,"blurHeight":0};